<template>
  <div
    class="preview"
    data-test-id="preview-frame"
  >
    <div class="row q-mt-xl q-mb-md relative-position">
      <div class="text-h5">
        Preview
      </div>
      <div
        v-if="showPreviewOptions"
        class="q-ml-md absolute-center"
      >
        <q-btn-group push>
          <q-btn
            v-for="option in previewOptions"
            :key="option.value"
            :label="option.label"
            :color="previewType === option.value ? 'primary' : 'black'"
            :flat="previewType !== option.value"
            size="md"
            @click="handleInput(option.value)"
          >
            <q-tooltip :delay="1000">
              {{ option.tooltip }}
            </q-tooltip>
          </q-btn>
        </q-btn-group>
      </div>
    </div>
    <div class="content">
      <div
        class="media_container"
        :class="previewType"
      >
        <iphone-header-bar v-if="!isDesktop" />
        <q-scroll-area
          :delay="1200"
          :class="{
            previewType,
            'q-pr-xs': !isDesktop,
          }"
          class="position-relative q-scrollarea__content_relative"
          style="height: 100%; position: relative!important;"
        >
          <slot name="sections" />
        </q-scroll-area>
      </div>
    </div>
  </div>
</template>

<script>
import { PREVIEW_OPTIONS } from 'src/models/page/Section'
import IphoneHeaderBar from 'src/modules/consumer/components/IphoneHeaderBar'

export default {
  name: 'PreviewFrame',
  components: {
    IphoneHeaderBar
  },
  props: {
    showPreviewOptions: {
      type: Boolean,
      default: true,
      required: false
    },
    previewOptions: {
      type: [Array],
      default: () => PREVIEW_OPTIONS.ALL,
      required: false
    },
    initialPreviewType: {
      type: String,
      default: PREVIEW_OPTIONS.MOBILE.value,
      required: false
    }
  },
  emits: ['update:model-value'],
  data () {
    return {
      previewType: this.initialPreviewType
    }
  },
  computed: {
    isDesktop () {
      return this.previewType === PREVIEW_OPTIONS.DESKTOP.value
    }
  },
  watch: {
    initialPreviewType: {
      handler (value, oldValue) {
        if (value === oldValue) {
          this.previewType = value
        }
      }
    },
    previewType: {
      handler (value) {
        this.$emit('update:model-value', value)
      }
    }
  },
  created () {
    _.extend(this, { PREVIEW_OPTIONS })
  },
  methods: {
    handleInput (value) {
      this.previewType = value
    }
  }
}
</script>

<style lang="scss" scoped>
.preview {
  width: 100%;
}
.close-open {
  position: fixed;
  right: calc(5% + 370px);
  top: 40%;
  background: #000;
  color: #fff;
  font-size: 12px;
  padding: 5px 10px;
  border-radius: 5px 0px 0px 5px;
  cursor: pointer;
  z-index: 9999;
}
.active {
  opacity: 1 !important;
}
.media_container {
  position: relative;
  margin: 40px auto;
  height: 750px;
  background-color: $background;
  border-radius: 40px;
  box-shadow: 0px 0px 0px 11px #1f1f1f, 0px 0px 0px 13px #191919, 0px 0px 0px 20px #111;
  transition: all 0.1s ease-in-out;
  overflow: hidden;
  &:before,
  &:after{
    content: '';
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
  }
  // home button indicator
  &:after {
    bottom: 7px;
    width: 140px;
    height: 4px;
    background-color: #f2f2f2;
    border-radius: 10px;
  }
}
.mobile, .app {
  width: 380px;
}
.desktop {
  width: 100%;
  border-radius: 20px;
}
.zoom{
  zoom: 0.9;
}
q-scroll-area.desktop {
  width: 1030px;
}
q-scroll-area.app, q-scroll-area.mobile {
  width: 380px;
}
</style>
<style lang="scss">
.q-scrollarea__content_relative .q-scrollarea__content {
  position: relative;
}
</style>
